module.exports = __webpack_public_path__ + "img/img2.d2ecca24.jpg";